<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { useNotifications } from "@/notifications/useNotifications";
import { useGetSettings } from "@/settings/settingsCrud";
import { useRouter } from "vue-router";
import AreaForm from "./AreaForm.vue";
import { useCreateArea, useNewArea } from "./areasCrud";

const router = useRouter();

const { addPendingNotification } = useNotifications();
const { area } = useNewArea();
const { settings, getSettingsStatus } = useGetSettings();
const { createArea, createAreaStatus } = useCreateArea({
  onSuccess: () => {
    addPendingNotification("Das Gebiet wurde erfolgreich gespeichert.");
    router.push({ name: "editArea", params: { id: area.value.id } });
  },
});
</script>

<template>
  <ManagementLayout
    :breadcrumbs="[
      { label: 'Gebiete', to: { name: 'areas' } },
      { label: 'Gebiet erstellen' },
    ]"
  >
    <template #header>
      <h1>Gebiet erstellen</h1>
    </template>
    <div>
      <HandleQueryStatus :query-status="getSettingsStatus">
        <AreaForm
          v-if="settings !== undefined"
          :area="area"
          :updating-status="createAreaStatus"
          :default-map-position="settings.defaultMapPosition"
          @update="createArea"
        />
      </HandleQueryStatus>
    </div>
  </ManagementLayout>
</template>
